export const transformCodePropParameter = 'transformCodeProp';

export const storyByPropParameter = 'storyByProp';
